var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button-base',{staticClass:"button-login",attrs:{"data-role":_vm.userRole},on:{"click":_vm.clickEvent}},[_c('image-base',{staticClass:"button-login__icon",attrs:{"src":require(`@/assets/img/common/icon/login.svg`)}}),_c('div',{staticClass:"button-login__text"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }